export default __webpack_public_path__ + "static/media/landingPage.dd53b79a.png";